import api from './api';

export const cajaService = {
    // Verificar si el usuario tiene caja abierta
    consultarEstado: async (usuario_id) => {
        try {
            const response = await api.get(`/caja/status?usuario_id=${usuario_id}`);
            return response.data;
        } catch (error) {
            console.error('Error checking caja status:', error);
            throw error;
        }
    },

    // Abrir una nueva sesión
    abrirCaja: async (data) => {
        try {
            const response = await api.post('/caja/abrir', data);
            return response.data;
        } catch (error) {
            console.error('Error opening caja:', error);
            throw error;
        }
    },

    // Obtener datos preliminares para el cierre (Pre-Cierre)
    obtenerPreCierre: async (sesion_id) => {
        try {
            const response = await api.get(`/caja/precierre/${sesion_id}`);
            return response.data;
        } catch (error) {
            console.error('Error getting precierre:', error);
            throw error;
        }
    },

    // Cerrar la caja con el arqueo realizado
    cerrarCaja: async (sesion_id, data) => {
        console.log('🟣 cajaService: cerrarCaja called');
        console.log('🟣 cajaService: Sesion ID:', sesion_id);
        console.log('🟣 cajaService: Data:', data);
        try {
            const url = `/caja/cerrar/${sesion_id}`;
            console.log('🟣 cajaService: Making POST request to:', url);
            const response = await api.post(url, data);
            console.log('🟣 cajaService: Response received:', response.data);
            return response.data;
        } catch (error) {
            console.error('🔴 cajaService: Error closing caja:', error);
            console.error('🔴 cajaService: Error response:', error.response?.data);
            console.error('🔴 cajaService: Error status:', error.response?.status);
            throw error;
        }
    },

    // Registrar un movimiento manual (Gasto, Depósito)
    registrarMovimiento: async (data) => {
        try {
            const response = await api.post('/caja/movimiento', data);
            return response.data;
        } catch (error) {
            console.error('Error registering movement:', error);
            throw error;
        }
    },

    eliminarMovimiento: async (id) => {
        try {
            const response = await api.delete(`/caja/movimientos/${id}`);
            return response.data;
        } catch (error) {
            console.error('Error deleting movement:', error);
            throw error;
        }
    },

    // Listar historial de sesiones
    listarHistorial: async (filters = {}) => {
        try {
            const params = new URLSearchParams(filters).toString();
            const response = await api.get(`/caja/historial?${params}`);
            return response.data;
        } catch (error) {
            console.error('Error listing history:', error);
            throw error;
        }
    },

    // Editar detalles de una sesión (Admin)
    editarSesion: async (id, data) => {
        try {
            const response = await api.put(`/caja/sesiones/${id}`, data);
            return response.data;
        } catch (error) {
            console.error('Error editing session:', error);
            throw error;
        }
    },

    // Reabrir una sesión cerrada (Admin)
    reabrirSesion: async (sesion_id) => {
        try {
            const response = await api.post(`/caja/sesiones/${sesion_id}/reabrir`);
            return response.data;
        } catch (error) {
            console.error('Error reopening session:', error);
            throw error;
        }
    },

    // Eliminar una sesión (Admin)
    eliminarSesion: async (sesion_id) => {
        try {
            const response = await api.delete(`/caja/sesiones/${sesion_id}`);
            return response.data;
        } catch (error) {
            console.error('Error deleting session:', error);
            throw error;
        }
    },

    // Obtener Resumen Global Diario (Admin)
    obtenerResumenGlobal: async (fecha = null) => {
        try {
            const params = fecha ? { fecha } : {};
            const response = await api.get('/caja/resumen-global', { params });
            return response.data;
        } catch (error) {
            console.error('Error getting global summary:', error);
            throw error;
        }
    },

    // Obtener Movimientos de una sesión
    obtenerMovimientosSesion: async (sesion_id) => {
        try {
            const response = await api.get(`/caja/sesion/${sesion_id}/movimientos`);
            return response.data;
        } catch (error) {
            console.error('Error getting session movements:', error);
            throw error;
        }
    },

    // Obtener datos detallados para el reporte de caja
    obtenerDatosReporte: async (sesion_id) => {
        try {
            const response = await api.get(`/caja/sesion/${sesion_id}/datos-reporte`);
            return response.data;
        } catch (error) {
            console.error('Error getting report data:', error);
            throw error;
        }
    },

    // Obtener Análisis de Ingresos para Arqueo
    obtenerAnalisisIngresos: async (usuario_id, modo = 'EFECTIVO') => {
        try {
            const response = await api.get(`/caja/analisis-ingresos?usuario_id=${usuario_id}&modo=${modo}`);
            return response.data;
        } catch (error) {
            console.error('Error getting income analysis:', error);
            throw error;
        }
    },

    // Actualizar desglose de conceptos de una sesión (Regularización)
    actualizarDesgloseSesion: async (sesion_id, desglose_conceptos) => {
        try {
            const response = await api.put(`/caja/sesiones/${sesion_id}/desglose`, { desglose_conceptos });
            return response.data;
        } catch (error) {
            console.error('Error updating session breakdown:', error);
            throw error;
        }
    },

    // Asignar conceptos a egresos de forma masiva
    asignarConceptosEgresos: async (asignaciones) => {
        try {
            const response = await api.post('/caja/egresos/asignar-conceptos', { asignaciones });
            return response.data;
        } catch (error) {
            console.error('Error assigning concepts to expenses:', error);
            throw error;
        }
    },

    // Obtener Reporte Global de Conceptos (Admin)
    obtenerReporteGlobalConceptos: async (filters = {}) => {
        try {
            const params = new URLSearchParams(filters).toString();
            const response = await api.get(`/caja/reporte-global-conceptos?${params}`);
            return response.data;
        } catch (error) {
            console.error('Error getting global concept report:', error);
            throw error;
        }
    },

    // Validar datos de caja y detectar inconsistencias
    validarDatosCaja: async (filters = {}) => {
        try {
            const params = new URLSearchParams(filters).toString();
            const response = await api.get(`/caja/validacion-datos?${params}`);
            return response.data;
        } catch (error) {
            console.error('Error validating caja data:', error);
            throw error;
        }
    },

    // Obtener detalles de pagos para un concepto (Admin)
    obtenerDetalleConcepto: async (filters = {}) => {
        try {
            const params = new URLSearchParams(filters).toString();
            const response = await api.get(`/caja/concepto-detalle?${params}`);
            return response.data;
        } catch (error) {
            console.error('Error getting concept details:', error);
            throw error;
        }
    },

    // --- Caja Chica Methods ---
    obtenerSaldoChica: async (modulo = 'CHICA') => {
        const response = await api.get('/caja/chica/saldo', { params: { modulo } });
        return response.data;
    },
    obtenerResumenDashboard: async (modulo = 'CHICA', usuario_id = null) => {
        const params = { modulo };
        if (usuario_id) params.usuario_id = usuario_id;
        const response = await api.get('/caja/chica/dashboard', { params });
        return response.data;
    },
    listarMovimientosChica: async (modulo = 'CHICA', solo_mios = false, usuario_id = null, limit = 50, fecha_desde = null, fecha_hasta = null) => {
        const params = { modulo, solo_mios: solo_mios ? 'true' : 'false', limit };
        if (usuario_id) params.usuario_id = usuario_id;
        if (fecha_desde) params.fecha_desde = fecha_desde;
        if (fecha_hasta) params.fecha_hasta = fecha_hasta;
        const response = await api.get('/caja/chica/movimientos', { params });
        return response.data;
    },
    obtenerMisTotales: async (modulo = 'CHICA') => {
        const response = await api.get('/caja/chica/mis-totales', { params: { modulo } });
        return response.data;
    },
    obtenerReporteUsuarios: async (modulo = 'CHICA', fecha_desde = null, fecha_hasta = null) => {
        const params = { modulo };
        if (fecha_desde) params.fecha_desde = fecha_desde;
        if (fecha_hasta) params.fecha_hasta = fecha_hasta;
        const response = await api.get('/caja/chica/reporte-usuarios', { params });
        return response.data;
    },
    listarUsuariosAdmin: async () => {
        const response = await api.get('/caja/chica/usuarios-admin');
        return response.data;
    },
    registrarMovimientoChica: async (formData) => {
        // formData must be FormData object for files
        const response = await api.post('/caja/chica/registrar', formData, {
            headers: { 'Content-Type': 'multipart/form-data' }
        });
        return response.data;
    },
    actualizarMovimientoChica: async (id, data) => {
        const config = data instanceof FormData ? {
            headers: { 'Content-Type': 'multipart/form-data' }
        } : {};
        const response = await api.put(`/caja/chica/movimiento/${id}`, data, config);
        return response.data;
    },
    anularMovimientoChica: async (id, motivo, usuario_id) => {
        const response = await api.post(`/caja/chica/anular/${id}`, { motivo, usuario_id });
        return response.data;
    },
    transferirFondosChica: async (data) => {
        // data should include 'modulo'
        const response = await api.post('/caja/chica/transferir', data);
        return response.data;
    },
    // Nuevas funciones para transferencia entre usuarios
    solicitarTransferenciaUsuario: async (data) => {
        const response = await api.post('/caja/chica/transferencias/solicitar', data);
        return response.data;
    },
    listarTransferencias: async (modulo = 'CHICA') => {
        const response = await api.get('/caja/chica/transferencias', { params: { modulo } });
        return response.data;
    },
    listarTransferenciasPendientes: async (modulo = 'CHICA') => {
        const response = await api.get('/caja/chica/transferencias/pendientes', { params: { modulo } });
        return response.data;
    },
    gestionarTransferencia: async (id, accion) => {
        const response = await api.post(`/caja/chica/transferencias/${id}/gestionar`, { accion });
        return response.data;
    },
    realizarCanjeChica: async (data) => {
        const response = await api.post('/caja/chica/canje', data);
        return response.data;
    },
    realizarDepositoChica: async (data) => {
        const response = await api.post('/caja/chica/deposito', data);
        return response.data;
    },
    // Conceptos
    listarConceptos: async (modulo = 'CHICA') => {
        const response = await api.get('/caja/conceptos', { params: { modulo } });
        return response.data;
    },
    crearConcepto: async (data) => {
        const response = await api.post('/caja/conceptos', data);
        return response.data;
    },
    actualizarConcepto: async (id, data) => {
        const response = await api.put(`/caja/conceptos/${id}`, data);
        return response.data;
    },
    eliminarConcepto: async (id) => {
        const response = await api.delete(`/caja/conceptos/${id}`);
        return response.data;
    },
    // Utils
    buscarAlumnos: async (anio_lectivo_id, search) => {
        // Anio arg ignored now, but kept for signature compatibility if needed
        const response = await api.get(`/alumnos/search`, {
            params: { query: search }
        });
        return response.data;
    },
    // IA / OCR
    procesarComprobanteIA: async (file) => {
        const formData = new FormData();
        formData.append('imagen', file);
        const response = await api.post('/ocr/procesar-comprobante', formData, {
            headers: { 'Content-Type': 'multipart/form-data' }
        });
        return response.data;
    },
    // IA - Analyze existing image by URL path
    procesarComprobanteIADesdeUrl: async (imagenUrl) => {
        const response = await api.post('/ocr/procesar-comprobante-url', { imagen_url: imagenUrl });
        return response.data;
    },
    getReporteProveedores: async (year = 2026, modulo = 'CHICA') => {
        const response = await api.get('/egresos/reporte-proveedores', { params: { year, modulo } });
        return response.data;
    },
    consultarDni: async (dni) => {
        const response = await api.get(`/consulta-dni/${dni}`);
        return response.data;
    },
    consultarRuc: async (ruc) => {
        const response = await api.get(`/consulta-ruc/${ruc}`);
        return response.data;
    }
};
